import AddIcon from '@mui/icons-material/Add';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { Box, Button, Grid } from '@mui/material';
import { createOrderLineAssignmentAction } from '_models/redux/create-order-line-assignment/action';
import { cleanCreateOrderLineAssignment } from '_models/redux/create-order-line-assignment/clean-action';
import { getOrdersAssignments } from '_models/redux/get-orders-assignments/action';
import { cleanOrdersAssignments } from '_models/redux/get-orders-assignments/clean-action';
import { connect } from 'react-redux';
import { OrdersTable } from '../components/OrdersTable';
import { SearchOrdersForm } from '../components/SearchOrdersForm';
import StatusPopup from '../components/StatusPopup';
import { useSearchOrder } from '../hooks/useSearchOrder';

const SearchOrdersPage = ({
  ordersAssignments,
  getOrdersAssignments,
  cleanOrdersAssignments,
  createOrderLineAssignment,
  createOrderLineAssignmentAction,
  cleanCreateOrderLineAssignment,
}) => {
  const {
    handleSubmit,
    onSubmit,
    register,
    control,
    errors,
    mappedRows,
    loading,
    Columns,
    isDialogOpen,
    dialogMessage,
    dialogTitleMessage,
    handleClose,
    shouldSearch,
    rfc,
    supplier,
    createOrder,
    page,
    size,
    filteredRows,
    statusOptions,
    statusFilter,
    setStatusFilter,
    orderIdFilter,
    setOrderIdFilter,
    dateFilter,
    setDateFilter,
    taxDataValidations,
    setValue,
  } = useSearchOrder({
    ordersAssignments,
    getOrdersAssignments,
    cleanOrdersAssignments,
    createOrderLineAssignment,
    createOrderLineAssignmentAction,
    cleanCreateOrderLineAssignment,
  });

  return (
    <Box>
      <Grid
        size={{ xs: 12 }}
        display={'flex'}
        justifyContent={'space-between'}
        alignContent={'center'}
        flexDirection={{ xs: 'column', md: 'row' }}
        gap={2}
      >
        <h4>Búsqueda por RFC</h4>
        {rfc && (
          <span style={{ fontSize: 14 }}>
            {supplier} - RFC <strong>({rfc})</strong>
          </span>
        )}
      </Grid>

      <Grid
        size={{ xs: 12 }}
        display={'flex'}
        justifyContent={'space-between'}
        alignContent={'center'}
        flexDirection={{ xs: 'column', md: 'row' }}
        gap={2}
      >
        <SearchOrdersForm
          taxDataValidations={taxDataValidations}
          loading={loading}
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
          register={register}
          control={control}
          errors={errors}
          setValue={setValue}
        />
        <Grid container size={{ xs: 12, md: 6 }} alignItems={'center'} justifyContent={'end'}>
          {mappedRows.length > 0 && (
            <Button
              onClick={createOrder}
              variant='outlined'
              startIcon={<AddIcon />}
              style={{ color: '#6242a2', backgroundColor: '#f2effb' }}
            >
              Nueva orden
            </Button>
          )}
        </Grid>
      </Grid>

      {/* TABLE HERE */}
      <Grid>
        <OrdersTable
          mappedRows={filteredRows}
          hasEndpointRows={mappedRows.length > 0}
          Columns={Columns}
          loading={loading}
          shouldSearch={shouldSearch}
          rfc={rfc}
          createOrder={createOrder}
          page={page}
          size={size}
          statusOptions={statusOptions}
          statusFilter={statusFilter}
          setStatusFilter={setStatusFilter}
          orderIdFilter={orderIdFilter}
          setOrderIdFilter={setOrderIdFilter}
          dateFilter={dateFilter}
          setDateFilter={setDateFilter}
        />
      </Grid>
      <StatusPopup
        title={dialogTitleMessage}
        decription={dialogMessage}
        icon={<ErrorOutlineOutlinedIcon sx={{ fontSize: 40, color: '#f7af35' }} />}
        open={isDialogOpen}
        onClose={handleClose}
      />
    </Box>
  );
};

const mapStateToProps = (state) => ({
  ordersAssignments: state.ordersAssignments,
  createOrderLineAssignment: state.createOrderLineAssignment,
});

const mapDispatchToProps = {
  getOrdersAssignments,
  cleanOrdersAssignments,
  createOrderLineAssignmentAction,
  cleanCreateOrderLineAssignment,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchOrdersPage);
